/* eslint-disable no-shadow */
import usePandaDispatcher from '@/composables/marketplace/panda/usePandaDispatcher';
import useSellerControlRoomDispatcher from '@/composables/sellerControlRoom/useSellerControlRoomDispatcher';
import {
  UPDATE_PUBNUB_ONLINE_STATUS,
  SET_PUBNUB_ONLINE_STATUS,
  UPDATE_IDLE_STATUS,
  START_IDLE_TIMER,
  CLEAR_IDLE_TIMER,
  SET_IDLE_STATUS,
  SET_IDLE_TIMER,
} from './network.type';

const initialState = {
  pubnubOnlineStatus: true,
  idleStatus: false,
  timer: 0,
};

export const state = { ...initialState };

export const actions = {
  [UPDATE_PUBNUB_ONLINE_STATUS]({ commit }, newOnlineStatus) {
    commit(SET_PUBNUB_ONLINE_STATUS, newOnlineStatus);
  },
  [UPDATE_IDLE_STATUS]({ commit }, newIdleStatus) {
    commit(SET_IDLE_STATUS, newIdleStatus);
    const { dispatchEvent: dispatchPandaEvent } = usePandaDispatcher('host-status');
    dispatchPandaEvent({ idleStatus: newIdleStatus });
    const { dispatchEvent: dispatchScrEvent } = useSellerControlRoomDispatcher('host-status');
    dispatchScrEvent({ idleStatus: newIdleStatus });
  },
  [START_IDLE_TIMER]({ commit, dispatch }) {
    const idleTimer = setTimeout(() => {
      dispatch(UPDATE_IDLE_STATUS, true);
    }, import.meta.env.VITE_IDLE_STATUS_TIMER);
    commit(SET_IDLE_TIMER, idleTimer);
  },
  [CLEAR_IDLE_TIMER]({ state, commit, dispatch }) {
    clearInterval(state.timer);
    commit(SET_IDLE_TIMER, null);
    if (state.idleStatus) {
      dispatch(UPDATE_IDLE_STATUS, false);
    }
  },
};

export const mutations = {
  [SET_PUBNUB_ONLINE_STATUS](state, newOnlineStatus) {
    state.pubnubOnlineStatus = newOnlineStatus;
  },
  [SET_IDLE_STATUS](state, newIdleStatus) {
    state.idleStatus = newIdleStatus;
  },
  [SET_IDLE_TIMER](state, timer) {
    state.timer = timer;
  },
};

export const getters = {
  isPubnubOnline(state) {
    return state.pubnubOnlineStatus;
  },
  isIdle(state) {
    return state.idleStatus;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
